import React from "react";
import { useIsLive } from "@/lib/liveHosts";
import { useI18n } from "@/context/I18nContext";

// Wraps an avatar node. When `uid` is currently live-streaming, it shows a
// red pulsing ring + LIVE badge and tapping it joins the stream.
export default function LiveRing({ uid, children, badge = true, className = "" }) {
  const { t } = useI18n();
  const session = useIsLive(uid);
  if (!session) return children;

  const join = (e) => {
    e.stopPropagation();
    e.preventDefault();
    window.dispatchEvent(new CustomEvent("rc-live-join", { detail: { session } }));
  };

  return (
    <span
      onClick={join}
      role="button"
      data-testid={`live-ring-${uid}`}
      className={`relative inline-flex shrink-0 cursor-pointer rounded-full ring-2 ring-red-500 ring-offset-2 ring-offset-[var(--rc-bg)] rc-live-pulse ${className}`}
    >
      {children}
      {badge && (
        <span className="pointer-events-none absolute -bottom-1.5 left-1/2 z-10 -translate-x-1/2 rounded-full bg-red-600 px-1.5 py-px text-[8px] font-bold leading-tight text-white shadow">
          {t("live_badge")}
        </span>
      )}
    </span>
  );
}
